// Core
import styled, { css } from 'styled-components';

export const InputWrapper = styled.div`
  position : relative;
  overflow: hidden;
  label {
    color: ${({ theme }) => theme.inputLabelColor};
    margin-bottom: 6px;
    display: block;
    font-weight: 300;
  }

  input {
    display: block;
    width: 100%;
    border: 1px solid #969fad;
    outline: none;
    background-color: #fff;
    height: 40px;
    font-size: .8rem;
    padding: 0 20px;
    border-radius: 0px;
    font-weight: 400;
    color: #6e6e6e;
    transition: 0.1s;
    &:focus{
      border: 2px solid ;
    }
  }

  /* Chrome, Safari, Edge, Opera */
  input::-webkit-outer-spin-button,
  input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  /* Firefox */
  input[type='number'] {
    -moz-appearance: textfield;
  }

}

  ${({ error }) =>
    error &&
    css`
      label {
        color: #e35061;
        font-weight: 600;
      }
      p {
        color: #e35061;
        font-weight: 400;
        margin: 0;
        font-size: 14px;
        margin-left: 20px;
    }
    input {
      border-color: #e35061 !important;
    }
      }
    `}
`;
